/* global moment swal angular _ */

import './style.less';
import { uniq, keyBy, orderBy } from 'lodash';
import modalTemplate from 'modals/marketplace/template.html';
import modalController from 'modals/marketplace/controller';

export default function(
  $log,
  $location,
  $scope,
  $stateParams,
  $state,
  $filter,
  $uibModal,
  Swal,
  ApiClass,
  CoursesClass,
  EventClass,
  HelperClass,
  ProfileClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.isAdmin = !!($state.$current.includes && $state.$current.includes['app.admin']);

  const { company_id, profile_uid, first, last, email } = ProfileClass.profileComplete.profile;

  const acceptRequest = request => {
    request.laddaAcceptReject = true;
    const body = {
      status: 'accepted',
      response: {
        profile_uid,
        first,
        last,
        email,
        response_date: new Date().toISOString()
      }
    };

    ApiClass.productsRequestsIdPatch({ id: request.uuid, manage: true }, body)
      .then(({ data: { item: { status, response } } }) => {
        request.status = status;
        request.response = response;
        request.laddaAcceptReject = false;
      })
      .catch(error => {
        request.laddaAcceptReject = false;
        if (error.dismiss) return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.reject = request => {
    request.laddaAcceptReject = true;
    Swal.input('Decline Request', 'Add a message to the user', '', 'textarea')
      .then(({ dismiss, value: message }) => {
        if (dismiss) {
          return Promise.reject('dismiss');
        }
        const body = {
          status: 'declined',
          response: {
            message,
            profile_uid,
            first,
            last,
            email,
            response_date: new Date().toISOString()
          }
        };

        return ApiClass.productsRequestsIdPatch({ id: request.uuid, manage: true }, body);
      })
      .then(({ data: { item: { status, response } } }) => {
        request.status = status;
        request.response = response;
        Swal.toast('Request has been denied');
        request.laddaAcceptReject = false;
      })
      .catch(error => {
        request.laddaAcceptReject = false;
        if (error === 'dismiss') return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.cancelRequest = request => {
    request.laddaCancelRequest = true;

    Swal.confirm('Cancel Request', `Cancel the registration request for ${request.product_name}.`)
      .then(({ dismiss }) => {
        if (dismiss) {
          return Promise.reject('dismiss');
        }

        return ApiClass.productsRequestsIdDelete({ id: request.uuid }, {});
      })
      .then(response => {
        request.archived = true;
        Swal.toast('Request has been cancelled');
        request.laddaCancelRequest = false;
      })
      .catch(error => {
        request.laddaCancelRequest = false;
        if (error.dismiss || error === 'dismiss') return;
        $log.error(error);
        Swal.toast('Hold Up!, Somethings not quite right, please try again', 'error');
        throw error;
      });
  };

  vm.ngChangeQueryParams = (type, value) => $location.search(type, value);

  function setSearchParams() {
    const { search, type, status, pageSize, page } = $stateParams;
    if (search) vm.searchText = search;
    if (page) vm.page = page;
    if (pageSize) vm.pageSize = pageSize;
  }

  function getCourseOrEvent(event) {
    if (event.event_id) {
      return ApiClass.eventsIdGet({ id: event.event_id }).then(({ data: { event } }) => {
        vm.selectedEvent = event.delivery_location;
        return event;
      });
    } else if (event.course_id) {
      return ApiClass.coursesIdGet({ id: event.course_id }, {}, { queryParams: { 'joins:passes': true } }).then(
        ({ data: { course } }) => {
          return course;
        }
      );
    } else {
      return Promise.resolve(vm.eventOrCourse);
    }
  }

  function openEvent(event) {
    $uibModal
      .open({
        template: modalTemplate,
        controller: modalController(event),
        size: 'lg',
        backdrop: true
      })
      .result.catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });
  }

  vm.moreInfo = function(event) {
    event.laddaMoreInfo = true;
    getCourseOrEvent(event)
      .then(content => {
        event.laddaMoreInfo = false;
        openEvent(content);
      })
      .catch(error => {
        event.laddaMoreInfo = false;
      });
  };

  vm.registrationCallback = (response, params) => {
    $log.debug('registrationCallback', response, params);
    acceptRequest(params);
  };

  function activate() {
    $log.debug('Admin CPE Approvals Activated');
    vm.loaded = false;
    vm.error = {};

    setSearchParams();

    ApiClass.productsRequestsGet({}, {}, { queryParams: { manage: vm.isAdmin, includeArchived: true } })
      .then(response => {
        $log.debug('Admin Approvals Data', response);

        const {
          data: { items }
        } = response;

        vm.items = orderBy(items, ['sortDate'], ['desc']);
        vm.itemsDict = keyBy(items, 'uuid');
        vm.typeGroup = uniq(items.map(({ product_type }) => product_type));
        vm.statusGroup = uniq(items.map(({ status }) => status));
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };

        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cpeRequests/controller.js